import { DateService, PulseEnvironment, UTMTrackerService } from '@pulse/browser-shared';
import { PulseAttributes, PulseStorage, TrackerConfigurations } from '@pulse/common';
import { Subscription } from 'rxjs';
import { BatchQueue } from '../transport';
import { DeviceInfoService } from './device.info/device-info.service';
import { SessionService } from './session';

export class DeviceAttributesService {
    private KEY_LAST_ATTRIBUTE_SYNC = 'attr';
    private queueState: Subscription | undefined;

    constructor(
        private deviceInfoService: DeviceInfoService,
        private utmService: UTMTrackerService,
        private storage: PulseStorage, // PersistentStorage
        private date: DateService,
        private config: TrackerConfigurations,
        private sessionService: SessionService,
        private batchQueue: BatchQueue,
        private env: PulseEnvironment,
    ) {
        this.sessionService.newSessionGenerated$.subscribe((sessionGenerationTime) => {
            if (this.date.now() - sessionGenerationTime < 100) {
                this.send(true);
            }
        });
    }
    async send(forceSend = false) {
        const userAgent = this.getHints();
        const deviceAttributes = this.getDeviceAttributes();
        const attributes = this.utmService.getUTMParams();

        if (this.shouldSendHintsOld() || forceSend) {
            this.env.win.dataLayer?.push({
                pulse: 'attribute_hints',
                user_agent: userAgent,
            });
            if (attributes) {
                this.env.win.dataLayer?.push({
                    pulse: 'attribute',
                    ...attributes,
                    ...deviceAttributes,
                });
            } else {
                this.env.win.dataLayer?.push({
                    pulse: 'attribute',
                    ...deviceAttributes,
                });
            }
            this.queueState = this.batchQueue.queueEmpty$.subscribe(() => {
                this.sent();
            });
        }
    }

    getDeviceAttributes(): PulseAttributes {
        const screenInfo = this.deviceInfoService.getScreenInfo();
        const hardwareInfo = this.deviceInfoService.getHardwareInfo();
        const navInfo = this.deviceInfoService.getNavigatorInfo();
        const paOpenTime = Math.round(this.getOpenTime() / 1000);

        return {
            ...screenInfo,
            ...hardwareInfo,
            ...navInfo,
            pa_open_time: paOpenTime,
        };
    }

    getHints(): string {
        return this.deviceInfoService.getUserAgent();
    }

    private shouldSendHintsOld() {
        const lastSync = Number(this.storage.get(this.KEY_LAST_ATTRIBUTE_SYNC) || '0');
        const now = this.date.now();

        return now - lastSync > this.config.attributeSyncIntervalMS;
    }

    private sent() {
        this.queueState?.unsubscribe();
        this.storage.set(this.KEY_LAST_ATTRIBUTE_SYNC, this.date.now().toString());
    }

    getOpenTime(): number {
        const session = this.sessionService.getSession();
        const timeRegex = /^(\d+)_.*$/;
        const match = session.sessionId.match(timeRegex);
        let time = this.date.now();

        if (match) {
            time = Number(match[1]);
        }

        return time;
    }
}
